import ActionTypes from '../constants/ActionTypes';
import standardAction from '../../../utilities/standard-action';

export default function setRecentSearches(updated) {
  return standardAction(ActionTypes.SET_RECENT_SEARCHES, updated);
}
